// Global, server-synced setting controlling which MediaVisibility new uploads default to.
// Cached in localStorage for synchronous access, with the canonical value synced to the
// server via the settings view (see views/settings.ts).
import type { MediaVisibility } from './api.types';

export const DEFAULT_VISIBILITY_KEY = 'radish-default-upload-visibility';

const DEFAULT_VISIBILITY: MediaVisibility = 'private';

let _defaultVisibility: MediaVisibility = (() => {
  const stored = localStorage.getItem(DEFAULT_VISIBILITY_KEY);
  return stored === 'family' || stored === 'private' ? stored : DEFAULT_VISIBILITY;
})();

export function getDefaultVisibility(): MediaVisibility {
  return _defaultVisibility;
}

export function setDefaultVisibility(visibility: MediaVisibility): void {
  _defaultVisibility = visibility === 'family' ? 'family' : 'private';
  localStorage.setItem(DEFAULT_VISIBILITY_KEY, _defaultVisibility);
}
